.base main {
  padding: 0 !important;
}

.root {
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(2, 1fr);
  row-gap: 1px;
  column-gap: 1px;
  width: 100%;
  /* height: 100%; */
  background: var(--widget-header-background);

  & > * {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    background: var(--widget-background);
  }
}

.bold {
  margin: 0;
  font-weight: var(--font-weight-regular);
}

.content {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-evenly;
  max-height: 200px;
}

.graphics {
  width: 30%;
}

.legend {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1rem;
  border-top: 1px solid var(--widget-header-background);
}

.indicator {
  display: inline-block;
  width: 1em;
  height: 1em;
  margin-right: 0.5rem;
  vertical-align: middle;
  background-color: var(--secondary);
  border-radius: var(--radius-full);
  transform: translateY(-2px);

  &.primary {
    background: var(--primary);
  }
}

.period {
  color: var(--gray-600);
}

.item {
  color: var(--secondary);
  cursor: default;
  transform-origin: 50% 50%;
}

.primary {
  color: var(--primary);
}

.clickable {
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: var(--primary-light);
  }
}
